import { render, staticRenderFns } from "./ChangeRowsHeightMenu.vue?vue&type=template&id=0a478f1f&scoped=true"
import script from "./ChangeRowsHeightMenu.vue?vue&type=script&lang=js"
export * from "./ChangeRowsHeightMenu.vue?vue&type=script&lang=js"
import style0 from "./ChangeRowsHeightMenu.vue?vue&type=style&index=0&id=0a478f1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a478f1f",
  null
  
)

export default component.exports